module.exports = __webpack_public_path__ + "img/fruit_strawberry.09d01b70.png";